/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRefresher = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M13 17v5h-2v-5zm-4.366-1.17 1.732 1-2.5 4.33-1.732-1zm6.732 0 2.5 4.33-1.732 1-2.5-4.33zm1.464-2.196 4.33 2.5-1 1.732-4.33-2.5zm-9.66 0 1 1.732-4.33 2.5-1-1.732zM22 11v2h-5v-2zM7 11v2H2v-2zM3.84 6.134l4.33 2.5-1 1.732-4.33-2.5zm16.32 0 1 1.732-4.33 2.5-1-1.732zM16.134 2.84l1.732 1-2.5 4.33-1.732-1zm-8.268 0 2.5 4.33-1.732 1-2.5-4.33zM13 2v5h-2V2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgRefresher as Refresher };
